// src/pages/PublicForm.jsx
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import FormPreview from '../components/form-builder/FormPreview';
import { Box, Typography, CircularProgress } from '@mui/material';
import { useSelector } from 'react-redux';
import { selectUserData } from "../redux/slices/userDataSlice";

const PublicForm = () => {
const appToken = useSelector((state) => state.appToken.apptoken);
  const userData = useSelector((state) => state.loginData.loginData);
  const { formId } = useParams();
  const [formData, setFormData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`https://app.hhoms.com/api/form/Libraries/${formId}`, {
          headers: {
            ApplicationToken: appToken,
            User: userData.id,
          },
        });

        if (response.data.formLibraries && response.data.formLibraries[0]) {
          const formLibrary = response.data.formLibraries[0];
          const formContent = JSON.parse(formLibrary.formContent);

          // Doküman kontrol ayarlarını ve logo URL'sini birleştir
          const mergedSettings = {
            ...formContent.settings,
            documentControlEnabled: true,
            documentPrefix: formLibrary.documentPrefix || formContent.settings?.documentPrefix,
            documentCode: formLibrary.documentCode || formContent.settings?.documentCode,
            department: formLibrary.department || formContent.settings?.department
          };

          // Hesaplama alanı değerlerini çıkar
          const calculationValues = {};
          formContent.fields.forEach(field => {
            if (field.type === 'calculation' && field.calculationData) {
              calculationValues[field.id] = field.calculationData;
            }
          });

          setFormData({
            ...formContent,
            settings: mergedSettings,
            logo: formContent.logo,
            calculationValues
          });

          console.log('Form verileri:', {
            formLibrary,
            formContent,
            mergedSettings,
            logo: formContent.logo
          });
        } else {
          setError('Form bulunamadı veya yayınlanmamış');
        }
      } catch (err) {
        setError('Form yüklenirken bir hata oluştu');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [formId, userData.id, appToken]);

  useEffect(() => {
    // Settings değişikliklerini izle
    if (formData?.settings) {
      console.log('Güncel Settings:', formData.settings);
    }
  }, [formData?.settings]);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ textAlign: 'center', py: 8 }}>
        <Typography color="error">{error}</Typography>
      </Box>
    );
  }


  console.log('FormData (tam yapı):', formData);
  console.log('FormData Fields:', formData.fields);
  console.log('FormData Settings:', formData?.settings);

  return (
    <Box sx={{ p: 3 }}>
      {formData && (
        <FormPreview
          id="form-preview"
          formTitle={formData.title}
          formDescription={formData.description}
          formFields={formData.fields}
          settings={{
            ...formData.settings,
            documentControlEnabled: true,
            documentPrefix: formData.settings?.documentPrefix,
            documentCode: formData.settings?.documentCode,
            department: formData.settings?.department
          }}
          logoUrl={formData.logo}
          calculationValues={formData.calculationValues}
        />
      )}
    </Box>
  );
};

export default PublicForm;